import { LoaderFunction } from "react-router-dom";

import ContentRequests from "@/api/content/content.requests.ts";
import { queryClient } from "@/api/query-client.tsx";
import { CONTENT_KEYS } from "@/hooks/api/content.hooks.ts";
import { lang } from "@/utils/funcs.ts";

export const catalogFilterLoader: LoaderFunction = ({ params }) => {
  const { id } = params as { id: string };
  const token = localStorage.getItem("splay:token") || "";
  const catalogFilterCache = queryClient.getQueryData(CONTENT_KEYS.catalogFilter(lang, parseInt(id), token));
  if (catalogFilterCache) return catalogFilterCache;

  return queryClient.fetchQuery({
    queryKey: CONTENT_KEYS.catalogFilter(lang, parseInt(id), token),
    queryFn: () =>
      token ? ContentRequests.getCatalogFilter(parseInt(id)) : ContentRequests.getCatalogFilterNoAuth(parseInt(id)),
    staleTime: 1000 * 60 * 15,
  });
};
